require('slick-carousel')
require('./jquery_passive_events_support')
require('@fancyapps/fancybox')
require('lib/sidebar_box')
require('lib/detect_flash')
require('objectFitPolyfill')
require('lib/auto_expanding_textarea')
require('lib/back_to_top_button')

import 'core-js/stable/object/assign'
import 'core-js/stable/array/find'
import 'core-js/stable/dom-collections/for-each'
import 'core-js/stable/string/includes'

import { delegate } from 'tippy.js';

delegate('.chats', {
  target:'.chats-item__review',
  maxWidth: 180,
});

$('.comment-input').focus(function () {
  $('.chats__footer').addClass('focused').addClass('show-hint');
});

$('.comment-input').blur(function () {
  $('.chats__footer').removeClass('focused');
});

$().fancybox({
  selector: '[data-carousel="gallery"]',
  protect: true,
  smallBtn: true,
  loop: true,
  infobar: false,
  toolbar: false,
  video: {autoStart: true},
});

$('.slick-slider--game').slick({
  dots: false,
  slidesToShow: 1,
  arrows: true,
  mobileFirst: true,
  infinite: false
});

const sectionsToPopulate = ['.title-area__actions', '.mini-header__button', '.button_area .review__action']
const osNameRegexp = /os_name=(\w+)/;

$('.episode-item').on('click', function () {
  $(this).closest('.episode-list').find('.episode-item').removeClass('active');
  $(this).addClass('active');

  let $episode = $(this).find('.episode-item__data');
  $('.about-episode').fadeOut(250);
  $('.about-episode .desc').text($episode.find('.description').text());
  $('.about-episode .position').text($episode.find('.position').text());
  $('.about-episode').fadeIn(250);

  let hintEl = $episode.find('.hint').children().clone()
  $('.left-content .hint').fadeOut(function() {
    if (hintEl) {
      $('.left-content .hint').children().remove()
      $('.left-content .hint').append(hintEl)
      $('.left-content .hint').fadeIn()
    }
  })

  // Update platform buttons
  let episodePath = $episode.find('.box-button>*').attr('action')

  document.querySelectorAll('.cpb-platform__link:not(.active)').forEach(function setPlatformPath(el) {
    if (!episodePath) { return }

    let osNameMatches = $(el).attr('href').match(osNameRegexp) || []
    let platformParam = osNameMatches[0] || $(el).attr('data-platform');
    let join_symbol = episodePath.includes('?') ? '&' : '?'
    if (episodePath == '#') {
      $(el).attr('href', 'javascript:;')
      $(el).attr('data-platform', platformParam)
    } else {
      $(el).attr('href', episodePath + join_symbol + platformParam)
    }
  })

  sectionsToPopulate.forEach(function populateSection(section, index) {
    $(section).empty().append($episode.find('.box-button>*').clone())
    var buyButton = $(section).find('[data-fancybox]')
    var withBuyButton = $episode.find('.box-button [data-fancybox]').length > 0
    if (withBuyButton) {
      if (buyButton.length == 0) return

      buyButton.attr('data-fancybox', `${buyButton.attr('data-fancybox')}-${index}`)
      document.querySelectorAll('.cpb-platform__link:not(.active)').forEach(function setDataFancybox(plLink, index) {
        $(plLink).attr('data-fancybox', `purchase-confirmation-platform-${index}`)
        $(plLink).attr('data-src', buyButton.attr('data-src'))
        $(plLink).attr('data-options', buyButton.attr('data-options'))
      })
    } else {
      document.querySelectorAll('.cpb-platform__link:not(.active)').forEach(function setDataFancybox(plLink) {
        $(plLink).removeAttr('data-fancybox')
        $(plLink).removeAttr('data-src')
        $(plLink).removeAttr('data-options')
      })
    }
  })
});

// Setup platform links for games without episodes
let buyButton = $('.title-area__actions [data-fancybox]')
let withBuyButton = $('.title-area__actions [data-fancybox]').length > 0

if (withBuyButton) {
  document.querySelectorAll('.cpb-platform__link:not(.active)').forEach(function setDataFancybox(plLink, index) {
    $(plLink).attr('href', 'javascript:;')
    $(plLink).attr('data-fancybox', `purchase-confirmation-platform-${index}`)
    $(plLink).attr('data-src', buyButton.attr('data-src'))
    $(plLink).attr('data-options', buyButton.attr('data-options'))
  })
}

$('.episode-list').each(function () {
  $(this).find('.episode-item').first().addClass('active');
})

if ($('.about-game.review .approved')) {
  var button = $('.about-game.review .review__action');
  $('.about-game.review .approved .button_area').append(button);
}
